<template>
	<template v-if="allowPppGp">
		<StatsChartTitleWithDescription
			titleKey="gnss-visibility.header.gridpoints"
			descriptionKey="gnss-visibility.header.gridpointsTooltip"
			titleClass="pd-lg-x pd-md-top"
		/>
		<GnssVisibilityChartGroupGridpoint />
	</template>
	<StatsChartTitleWithDescription
		titleKey="satellites-per-base-station.header"
		descriptionKey="satellites-per-base-station.headerTooltip"
	/>
	<SatellitesPerBaseStationChartGroup />
</template>

<script>
import { computed } from 'vue';

import { useLicenseStore } from '@/stores/licenseStore';

import GnssVisibilityChartGroupGridpoint from '@/components/stats/GnssVisibilityChartGroupGridpoint';
import SatellitesPerBaseStationChartGroup from '@/components/stats/SatellitesPerBaseStationChartGroup';
import StatsChartTitleWithDescription from '@/components/stats/StatsChartTitleWithDescription.vue';

export default {
	components: {
		GnssVisibilityChartGroupGridpoint,
		SatellitesPerBaseStationChartGroup,
		StatsChartTitleWithDescription,
	},
	setup() {
		const licenseStore = useLicenseStore();
		const allowPppGp = computed(() => licenseStore.allowPppGp);

		return {
			allowPppGp,
		};
	},
}
</script>
